export const fontFaceDeclarations = `
    @font-face {
      font-family: "Proxima Nova";
      src: url("/fonts/proxima-nova-2/Mark-Simonson-Proxima-Nova-Regular.otf") format("opentype");
      font-weight: 400;
      font-style: normal;
    }

    @font-face {
      font-family: "Proxima Nova";
      src: url("/fonts/proxima-nova-2/Mark-Simonson-Proxima-Nova-Regular.otf") format("opentype");
      font-weight: 500;
      font-style: normal;
    }

    @font-face {
      font-family: "Proxima Nova";
      src: url("/fonts/proxima-nova-2/Mark-Simonson-Proxima-Nova-Bold.otf") format("opentype");
      font-weight: 600;
      font-style: normal;
    }

    @font-face {
      font-family: "Proxima Nova";
      src: url("/fonts/proxima-nova-2/Mark-Simonson-Proxima-Nova-Bold.otf") format("opentype");
      font-weight: 700;
      font-style: normal;
    }
  `;
